<template>
  <div>
    <BaseTabbedSection :tabs="tabs">
      <template #default="tabbedSectionProps">
        <component
          :is="tabbedSectionProps.currentTab.component"
          :contact-id="contactId"
          :contact="contact"
          @refresh="refreshContactMeta"
        />
      </template>
    </BaseTabbedSection>
  </div>
</template>

<script>
import components from './mainSection';

const buildTabTitleWithMeta = (label, meta) =>
  [label, meta ? `(${meta})` : false].filter(Boolean).join(' ');

export default {
  components,
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    tabs() {
      const {
        notesCount,
        accOrdersCount,
        tagsCount,
        purchasedAccProductsCount,
        accProductReactionsCount,
        contactRequestsCount,
        accountsCount,
        emailMessagesCount = 0,
        smsMessagesCount = 0,
      } = this.contact || {};

      return [
        {
          name: 'notes',
          label: buildTabTitleWithMeta(this.$t('contact.notes'), notesCount),
          component: components.NotesTab,
        },
        {
          name: 'tags',
          label: buildTabTitleWithMeta(this.$t('contact.tags'), tagsCount),
          component: components.TagsTab,
          includeRules: () =>
            this.$membershipHasPermissionTo('read tags') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'orders',
          label: buildTabTitleWithMeta(this.$t('contact.orders'), accOrdersCount),
          component: components.AccOrdersTab,
          includeRules: () =>
            this.$membershipHasPermissionTo('read acc orders') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'products',
          label: buildTabTitleWithMeta(this.$t('contact.products'), purchasedAccProductsCount),
          component: components.PurchasedAccProductsTab,
          includeRules: () =>
            this.$membershipHasPermissionTo('read acc products') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'product_reactions',
          label: buildTabTitleWithMeta(
            this.$t('contact.product_reactions'),
            accProductReactionsCount
          ),
          component: components.AccProductReactionsTab,
          includeRules: () =>
            this.$membershipHasPermissionTo('read acc products') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'contact_requests',
          label: buildTabTitleWithMeta(this.$t('contact.contact_requests'), contactRequestsCount),
          component: components.ContactRequestsTab,
          includeRules: () =>
            this.$membershipHasPermissionTo('read contact requests') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'clients',
          label: buildTabTitleWithMeta(this.$t('contact.clients'), accountsCount),
          component: components.AccountsTab,
          includeRules: () => this.$isAdminOrSuperAdmin,
        },
        {
          name: 'activity',
          label: buildTabTitleWithMeta(
            this.$t('contact.activity'),
            emailMessagesCount + smsMessagesCount
          ),
          component: components.ActivityTab,
        },
        {
          name: 'activity_logs',
          label: this.$t('contact.activityLogs'),
          component: components.ActivitiesTab,
        },
        {
          name: 'import_errors',
          label: this.$t('contact.import_errors'),
          component: components.ImportErrorsTab,
          includeRules: () => {
            if (this.contact?.createdVia !== 'import') {
              return false;
            }
            return Object.keys(this.contact?.postImportActionErrors || {}).length > 0;
          },
        },
      ].filter((tab) => {
        if (typeof tab.includeRules !== 'undefined') {
          return this.shouldInclude(
            Array.isArray(tab.includeRules) ? tab.includeRules : [tab.includeRules]
          );
        }

        return true;
      });
    },
  },
  methods: {
    shouldInclude(tests) {
      const passes = tests.every((pass) => pass());
      return passes;
    },
    async refreshContactMeta() {
      try {
        await this.$store.dispatch('ui/contacts/read', {
          id: this.contactId,
          query: {
            include: [
              'accOrdersCount',
              'notesCount',
              'purchasedAccProductsCount',
              'accProductReactionsCount',
              'contactRequestsCount',
              'accountsCount',
              'emailMessagesCount',
              'smsMessagesCount',
            ],
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
